import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import GenericFaq from '~/components/molecules/Editorial/Global/GenericFaq.vue';
export default {
  name: 'Faq',
  components: {
    TitleSection,
    SubtitleSection,
    SimpleParagraph,
    GenericFaq
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: null
    };
  },
  computed: {
    title() {
      return this.payload.primary.title[0] || {};
    },
    subtitle() {
      return this.payload.primary.subtitle[0] || {};
    },
    paragraph() {
      return this.payload.primary.paragraph || [];
    },
    faq() {
      return this.payload.items.map(item => ({
        question: item.question[0].text || '',
        answer: item.answer || []
      }));
    }
  },
  methods: {
    toggleFaq(index) {
      this.isOpen = this.isOpen === index ? null : index;
    }
  }
};